module.exports = __webpack_public_path__ + "img/lv7.809982de.png";